<div class="rg-login-page">
    <div class="rg-login-card">
        <div class="text-center mb-4">
            <div class="rg-login-logo mx-auto mb-3">
                <!-- <i class="bi bi-shield-lock-fill"></i> -->
                <div class="brand-mark">RG</div>
            </div>

            <h3 class="fw-bold mb-1">RiskGuard Licensing</h3>
            <p class="text-muted mb-0">Sign in to continue</p>
        </div>

        <form (ngSubmit)="submit()">
            <div class="alert alert-danger" *ngIf="errorMessage">
                {{ errorMessage }}
            </div>

            <div class="mb-3">
                <label class="form-label">Email address</label>
                <input type="email" class="form-control form-control-lg" placeholder="admin@riskguard.com" name="email"
                    [(ngModel)]="email">
            </div>

            <div class="mb-3">
                <label class="form-label">Password</label>
                <input type="password" class="form-control form-control-lg" placeholder="Enter password" name="password"
                    [(ngModel)]="password">
            </div>

            <div class="text-end mb-3">
                <a href="javascript:void(0)" class="text-decoration-none" data-bs-toggle="modal"
                    data-bs-target="#forgotPasswordModal">
                    Forgot password?
                </a>
            </div>

            <button type="submit" class="btn btn-primary btn-lg w-100" [disabled]="loading">
                <span *ngIf="!loading">Sign In</span>
                <span *ngIf="loading">Signing in...</span>
            </button>
        </form>

        <div class="text-center mt-4">
            <small class="text-muted">RiskGuard Licensing Admin Portal</small>
        </div>
    </div>
</div>
<div class="modal fade" id="forgotPasswordModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rg-reset-modal">
      <div class="modal-header">
        <h5 class="modal-title fw-bold">Request Password Reset</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <form (ngSubmit)="submitPasswordResetRequest()">
        <div class="modal-body">
          <p class="text-muted">
            Enter your admin email. A RiskGuard administrator will review your request and reset your password.
          </p>

          <label class="form-label">Admin Email</label>
          <input
            type="email"
            class="form-control"
            name="resetEmail"
            placeholder="admin@riskguard.com"
            [(ngModel)]="resetEmail">
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
            Cancel
          </button>

          <button type="submit" class="btn btn-primary" [disabled]="submittingResetRequest">
            <span *ngIf="!submittingResetRequest">Submit Request</span>
            <span *ngIf="submittingResetRequest">Submitting...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>